import { useTranslation } from "react-i18next";
import byeImg from "../assets/bye.webp";

function LoggedOutPage(){
  const {t} = useTranslation();
  const inProduction = process.env.REACT_APP_ENV === "production";

  return(
    <div className="container-fluid">
      <div className="row">
        <div className="col px-4 px-lg-5 py-4 mt-3 mb-5 my-md-4 my-xl-5 text-center d-flex flex-row align-items-center justify-content-center gap-3 logOutBox">
          <p className="m-0">{t("loggedOut")}</p>
          {inProduction && <img src={byeImg} alt="goodbye"/> }
        </div>
      </div>
    </div>
  );
}

export default LoggedOutPage;